import React, { useState, useEffect } from "react";
import moment from "moment";
import { questionnaireList } from "@5tbim/services/questionnaire";
import Config from "@5tbim/config";

const getLogo = (attachments = []) => {
  const a = attachments.filter((attachment) => {
    return attachment.sourceType === "questionnaire-logo";
  });
  if (a.length) {
    return a[0].uri;
  }
  return "images/fa1.png";
};

function List({
  contentStyle = {},
  imageStyle = {
    // width: "400px",
    // maxWidth: "400px",
    // minWidth: "400px",
    // height: "225px",
    // minHeight: "225px",
    // maxHeight: "225px",
  },
}) {
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    (async () => {
      const pagination = {
        pageIndex: 1,
        pageSize: 4,
        orderby: [
          ["orderIndex", "desc"],
          ["startDate", "desc"],
        ],
      };
      const response = await questionnaireList({
        pagination,
      });
      if (response) {
        setDatas(response.data.rows);
      }
    })();
  }, []);

  return (
    <React.Fragment>
      {datas && datas.length
        ? datas.map((questionnaire) => {
            return (
              <div className="wrapcontainer__row__col" style={imageStyle}>
                <div className="contentItem">
                  <div className="contentItem__img" style={imageStyle}>
                    <a
                      rel="noopener noreferrer"
                      href={
                        Config.QuestionnaireDetail + "?id=" + questionnaire.id
                      }
                      target="_blank"
                    >
                      <img
                        alt=""
                        style={imageStyle}
                        src={
                          questionnaire.attachments &&
                          questionnaire.attachments.length
                            ? getLogo(questionnaire.attachments)
                            : "images/fa1.png"
                        }
                      ></img>
                    </a>
                  </div>
                  <div className="contentItem__content" style={contentStyle}>
                    <div className="contentItem__content__title">
                      <a
                        href={
                          Config.QuestionnaireDetail + "?id=" + questionnaire.id
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {questionnaire.title}
                      </a>
                    </div>
                    <div className="contentItem__content__subtitle">
                      发起单位：
                      {questionnaire.organization.name1
                        ? questionnaire.organization.name1 +
                          "/" +
                          questionnaire.organization.name
                        : questionnaire.organization.name}
                    </div>
                    <div className="contentItem__content__subtitle">
                      开始时间：
                      {moment(questionnaire.startDate).format("YYYY-MM-DD")}
                    </div>
                    <div className="contentItem__content__subtitle">
                      结束时间：
                      {moment(questionnaire.endDate).format("YYYY-MM-DD")}
                    </div>
                    {/* <div className="contentItem__content__desc">
                      <div
                        className="contentItem__content__subtitle"
                        dangerouslySetInnerHTML={{
                          __html: questionnaire.desc.replace(/\n/gi, ","),
                        }}
                      ></div>
                    </div> */}
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </React.Fragment>
  );
}

export default List;
